import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { UserFilter } from 'app/shared/filters/user.filter';
import { UserBase } from 'app/shared/models/user-base.model';
import { UserService } from 'app/shared/services/user.service';
import { SelectionListBaseComponent } from '../selection-list-base/selection-list-base.component';

@Component({
  selector: 'app-user-selection-list',
  templateUrl: './user-selection-list.component.html',
  styleUrls: ['./user-selection-list.component.scss']
})

export class UserSelectionListComponent extends SelectionListBaseComponent<UserBase> implements OnInit, OnChanges {

  @Input() companyId?: number;
  @Output() userChangedEvent: EventEmitter<UserBase> = new EventEmitter<UserBase>();

  constructor(private userService: UserService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companyId) {
      this.selectedObject = undefined;
      this.loadSelectionList();
    }
  }

  protected loadSelectionList(): void {
    this.selectionList$ = this.userService.getList<UserBase>('/users/list', new UserFilter(null, this.companyId));
  }
}
